import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    contentTypes: { type: Array, default: [] }
  }

  connect() {
    this.element.addEventListener('trix-file-accept', this.screenFile.bind(this))

    if (this.contentTypesValue.length === 0) {
      this.element.addEventListener('trix-attachment-add', event => event.attachment.remove())
    }
  }

  screenFile(event) {
    if (!this.contentTypesValue.includes(event.file.type)) {
      event.preventDefault()
      alert(`${event.file.type} is not a supported file type.`)
    }
  }

  process() {
    const attachments = this.element.editor.getDocument().getAttachments()
    this.dispatch('uploading', { detail: attachments.some(attachment => attachment.isPending()) })
  }
}
